import Modal from "../Modal";
import DeliveryAddressNewForm from "../../forms/deliveryAddress/DeliveryAddressNewForm";
import { useTranslation } from "../../../hooks/useTranslation";

export default function DeliveryAddressNewModal({show, handleClose, company_id, callback, title = null}) {
    const { t } = useTranslation();
    const defaultTitle = t("deliveryAddress.new");
    return (
        <Modal title={title || defaultTitle} show={show} handleClose={handleClose}>
            <DeliveryAddressNewForm handleClose={handleClose} company_id={company_id} callback={callback} />
        </Modal>
    );
};